<!-- [画面下部固定フローティングナビ] -->
<div class="l-bottom-float">
  <!-- [PC/TAB用 下部固定エリア内金額表示エリア] -->
  <div *ngIf="!isSp" class="p-bottom-float-navi02 p-bottom-float-navi02--has-promotion">
    <div class="p-bottom-float-navi02__wrap">
      <div class="p-bottom-float-navi02__inner">
        <div class="p-bottom-float-navi02__item">
          <div class="p-bottom-float-navi02__detail">
            <div
              class="p-bottom-float-navi02__detail-price"
              [innerHTML]="totalPrice | amountFormat : 'availability.bottomFloat_totalPrice' : currencyCode"
            ></div>
            <div class="p-bottom-float-navi02__detail-link">
              <a
                href="#"
                id="complex-flight-availability-pres-details"
                class="c-text-link-arrow01 c-text-link-arrow01--ss"
                (throttleClick$)="details($event)"
                aswThrottleClick
              >
                {{ 'm_static_message-label.details2' | staticMsg }}
              </a>
            </div>
            <div
              class="p-bottom-float-navi02__detail-info"
              [innerHTML]="'m_static_message-label.includeFareAndFuelCost' | staticMsg"
            ></div>
          </div>
        </div>
        <div class="p-bottom-float-navi02__item">
          <button
            id="complex-flight-availability-pres-continue"
            class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
            [disabled]="fareFamily.airOffers?.[0]?.isUnselectable || isWaitlisted()"
            (throttleClick$)="clickNextButton($event)"
            aswThrottleClick
          >
            <span class="c-btn-primary__text">{{ 'm_static_message-label.next' | staticMsg }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- [PC/TAB用 下部固定エリア内金額表示エリア] -->

  <!-- [SP用 下部固定エリア内金額表示エリア] -->
  <div *ngIf="isSp" class="p-bottom-float-navi03 p-bottom-float-navi03--has-promotion">
    <div class="p-bottom-float-navi03__wrap">
      <div class="p-bottom-float-navi03__inner">
        <div class="p-bottom-float-navi03__item">
          <div class="p-bottom-float-navi03__detail">
            <div
              class="p-bottom-float-navi03__detail-price"
              [innerHTML]="totalPrice | amountFormat : 'availability.bottomFloat_totalPrice' : currencyCode"
            ></div>
            <div class="p-bottom-float-navi03__detail-link">
              <a
                href="#"
                id="complex-flight-availability-pres-details2"
                class="c-text-link-arrow01 c-text-link-arrow01--ss"
                (throttleClick$)="details($event)"
                aswThrottleClick
                >{{ 'm_static_message-label.details2' | staticMsg }}</a
              >
            </div>
            <div
              class="p-bottom-float-navi03__detail-info"
              [innerHTML]="'m_static_message-label.includeFareAndFuelCost' | staticMsg"
            ></div>
          </div>
        </div>
        <div class="p-bottom-float-navi03__item">
          <button
            id="complex-flight-availability-pres-continue-sp"
            class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
            [disabled]="fareFamily.airOffers?.[0]?.isUnselectable || isWaitlisted()"
            (throttleClick$)="clickNextButton($event)"
            aswThrottleClick
          >
            <span class="c-btn-primary__text">{{ 'm_static_message-label.next' | staticMsg }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- [SP用 下部固定エリア内金額表示エリア] -->
</div>
